import {CustomerPortalRoleModel} from "../redux/types";
import {useAppSelector} from "../redux/hooks";
import {hasAnyRequiredCustomerPolicy} from "../util/role";

interface Props {
  children: any
  policy: keyof CustomerPortalRoleModel | (keyof CustomerPortalRoleModel)[]
}

export const RenderForCustomerPolicy = ({children, policy}: Props) => {
  const authenticatedUser = useAppSelector(state => state.auth.authenticatedUser)
  const currentCustomerId = useAppSelector(state => state.auth.currentCustomerId)

  const policies = Array.isArray(policy) ? policy : [policy];

  if (!hasAnyRequiredCustomerPolicy(authenticatedUser, currentCustomerId, ...policies)) {
    return null
  }

  return children
}
